import { render, staticRenderFns } from "./CentrosDeCosto_agregar.vue?vue&type=template&id=4c5154e2"
import script from "./CentrosDeCosto_agregar.vue?vue&type=script&lang=js"
export * from "./CentrosDeCosto_agregar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports